import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { Avatar, Button, Popover, Typography, App } from 'antd';
import { LogoutOutlined } from '@ant-design/icons';
import { useAuth } from 'contexts/AuthContext';
import { QUERY_KEYS } from 'feature/QueryKey';
import { fetchAdminProfile } from 'service/api';

const { Text } = Typography;

export default function Profile() {
  const [open, setOpen] = useState(false);
  const { token, logout } = useAuth();
  const { modal } = App.useApp();
  const { data: response } = useQuery({
    queryKey: [QUERY_KEYS.PROFILE],
    queryFn: fetchAdminProfile,
    enabled: Boolean(token)
  });

  const profile = response?.data?.data ?? response?.data ?? response;
  const name =
    profile?.fullName || profile?.name || [profile?.firstName, profile?.lastName].filter(Boolean).join(' ') || profile?.email || 'Admin';
  const initial = name.trim().charAt(0).toUpperCase();
  const profilePhoto = profile?.profilePhoto || undefined;

  const handleLogout = () => {
    modal.confirm({
      title: 'Are you sure you want to logout?',
      okText: 'Logout',
      cancelText: 'Cancel',
      onOk: () => {
        logout();
      }
    });
  };
  const content = (
    <div style={{ width: 280 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <Avatar size={36} src={profilePhoto} style={{ backgroundColor: '#81c21e' }}>
            {initial}
          </Avatar>
          <div>
            <Text strong style={{ display: 'block', fontSize: 13 }}>
              {name}
            </Text>
            <Text type="secondary" style={{ fontSize: 12 }}>
              {profile?.email || 'Welcome'}
            </Text>
          </div>
        </div>
        <Button type="text" danger shape="circle" onClick={handleLogout} icon={<LogoutOutlined />} />
      </div>
    </div>
  );

  return (
    <Popover content={content} trigger="click" open={open} onOpenChange={setOpen} placement="bottomRight">
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, cursor: 'pointer' }}>
        <div style={{ display: 'flex', flexDirection: 'column', lineHeight: 1.25 }}>
          <span className="text-[#81c21e] ">👋 Welcome</span>
          <Text strong style={{ fontSize: 13 }}>
            {name}
          </Text>
        </div>
        <Avatar size={40} src={profilePhoto} style={{ backgroundColor: '#81c21e' }}>
          {initial}
        </Avatar>
      </div>
    </Popover>
  );
}
